var _form = require('./form');

/**
 * Password field sub module
 */
module.exports = {
		
	/**
	 * initialize
	 */
	init: function(params) {
		var self = this;
		self.params = params;
		
		this.setUpShowPassword();
		this.checkErrors();
	},
	
	/**
	 * Attach events for show/hide password fields
	 */
	setUpShowPassword: function() {
		var self = this;
		
     	$('#toggle-password').change(function(e) {
     		$('#password, #confirmPassword').toggleClass('hidden');
    		$('#shadow-password, #shadow-confirmPassword').toggleClass('hidden');
    		if($.isFunction($.fn.placeholder)) {
	    		var $form = self.params.$form;
	    		var $passwordFields = e.target.checked === true ? $('input[id^=shadow]', $form) :  $('input[type=password]', $form);
	    		_form.initPasswordFielsPlaceholder($passwordFields);
    		}
     	});

 		$('#password, #confirmPassword, #shadow-password, #shadow-confirmPassword').on('keyup', function(e) {
						
			var $shadow = $('#shadow-'+this.id);
			var $nonShadow = $('#'+this.id.replace('shadow-', ''));			
			var $this = $(this);
			
			if($shadow.val() != $this.val()) {
				$shadow.val($(this).val());
			}
			
			if($nonShadow.val() != $this.val()) {
				$nonShadow.val($(this).val());
			}
			
 		});
	},
	
	/**
	 * check if the password fields have error
	 */
	checkErrors: function() {
		$('#shadow-password').toggleClass('has-error', $('#password').hasClass('has-error'));
		$('#shadow-confirmPassword').toggleClass('has-error', $('#confirmPassword').hasClass('has-error'));
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/password.js
// module id = 255
// module chunks = 4